import axiosInstance from "../Axios/axiosInstance";

const getAllInsurances = async () => {
  return await axiosInstance.get("/lifeInsurances/");
};

const getInsuranceById = async (id) => {
  return await axiosInstance.get(`/lifeInsurances/${id}`);
};

const addInsurance = async (data) => {
  console.log(data);
  return await axiosInstance.post("/lifeInsurances/", data);
};

const editInsurance = async (id, data) => {
  return await axiosInstance.put(`/lifeInsurances/${id}`, data);
};

const deleteInsurance = async (id) => {
  return await axiosInstance.delete(`/lifeInsurances/${id}`);
};

export default {
  getAllInsurances,
  getInsuranceById,
  addInsurance,
  editInsurance,
  deleteInsurance,
};
